export default __webpack_public_path__ + "static/media/indistruel.6f2b89ea.png";